import React from 'react';
import styled from 'styled-components';

import { VendorCard } from '@sayido/ui';

const Wrapper = styled.div`
  align-items: start;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 12px;

  @media (max-width: 440px) {
    display: block;
  }
`;

export default ({ vendors }) => {
  return (
    <Wrapper>
      {vendors.map((vendor, index) => (
        <VendorCard vendor={vendor} key={index} />
      ))}
    </Wrapper>
  );
};
